export default (value) => {
  const type = typeof value;
  return type === 'string';
};
